import HUBApi from '@/service/hub-api';

export default {
  createRegistrant(data) {
    return HUBApi.post('/events/registrants', data);
  },

  getRegistrants(webinarId) {
    return HUBApi.get(`/events/registrants/${webinarId}`);
  },
};
